import React from 'react';

import {getContentType} from 'app/utils/content-type';

import type {BasicRoleSerializedType} from 'sweet-types';

const teamCt = getContentType('team');

export const getRoleLabel = (role: BasicRoleSerializedType) => (
  <span>
    {role.name} (<i className={`fa-fw ${teamCt.icon}`} /> {role.team.name})
  </span>
);
